function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group 8");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "MOBILE",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "square"
}, React.createElement("g", {
  id: "IPHONE-Detailseite",
  transform: "translate(-29.000000, -12.000000)",
  fillRule: "nonzero",
  stroke: "#979797"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(30.000000, 12.000000)"
}, React.createElement("path", {
  d: "M0.425,1 L16.575,1",
  id: "Line"
}), React.createElement("path", {
  d: "M0.425,8.5 L16.575,8.5",
  id: "Line-Copy"
}), React.createElement("path", {
  d: "M0.425,16 L16.575,16",
  id: "Line-Copy-2"
}))));

var SvgBurger = function SvgBurger(props) {
  return React.createElement("svg", _extends({
    width: "19px",
    height: "17px",
    viewBox: "0 0 19 17"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/burger.90f34d15.svg";
export { SvgBurger as ReactComponent };